/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaCalendarCheck: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="calendarCheck" viewBox="0 0 24 24">
      <path
        d="M17 4V5C17 5.552 16.552 6 16 6C15.448 6 15 5.552 15 5V4H9V5C9 5.552 8.552 6 8 6C7.448 6 7 5.552 7 5V4H5C4.448 4 4 4.448 4 5V8H13.989C14.547 8 15 8.448 15 9C15 9.552 14.547 10 13.989 10H4V19C4 19.552 4.448 20 5 20H19C19.552 20 20 19.552 20 19V5C20 4.448 19.552 4 19 4H17ZM7 2V1C7 0.448 7.448 0 8 0C8.552 0 9 0.448 9 1V2H15V1C15 0.448 15.448 0 16 0C16.552 0 17 0.448 17 1V2H19C20.657 2 22 3.343 22 5V19C22 20.657 20.657 22 19 22H5C3.343 22 2 20.657 2 19V5C2 3.343 3.343 2 5 2H7ZM17.819 8.766C18.21 8.375 18.843 8.375 19.233 8.766C19.623 9.157 19.624 9.79 19.233 10.18L11.706 17.707C11.315 18.098 10.682 18.098 10.292 17.707L7.292 14.707C6.901 14.316 6.901 13.683 7.292 13.293C7.683 12.903 8.316 12.902 8.706 13.293L10.999 15.586L17.818 8.767L17.819 8.766Z"
        fill="currentColor"
      ></path>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaCalendarCheck)
